<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { type SeccionAjena, terminarSeccion, todasLasSecciones } from '@frontend/secciones/api-administrar-secciones';
import { textosAdministrarSecciones as textos } from '@frontend/secciones/textos-administrar-secciones';

const secciones = ref<SeccionAjena[]>([]);

async function cargar() {
  secciones.value = await todasLasSecciones();
}

async function terminar(seccion: SeccionAjena) {
  await terminarSeccion(seccion.id);
  await cargar();
}

onMounted(cargar);
</script>

<template>
  <section class="mx-auto max-w-4xl px-4 py-8">
    <h1 class="mb-6 text-3xl font-bold">{{ textos.titulo }}</h1>
    <ul>
      <li
        v-for="seccion in secciones"
        :key="seccion.id"
        :data-testid="`seccion-${seccion.slug}`"
        class="mb-4 flex items-center justify-between rounded border p-4"
      >
        <div>
          <h2 data-testid="nombre" class="text-xl font-semibold">{{ seccion.nombre }}</h2>
          <span data-testid="quien-la-maneja" class="text-sm text-gray-600">{{ seccion.quienLaManeja }}</span>
          <p v-if="seccion.congelada" data-testid="congelada" class="mt-1 text-sm text-amber-700">{{ textos.congelada }}</p>
        </div>
        <button
          data-testid="terminar-seccion"
          class="rounded-md border border-red-600 px-3 py-1 text-sm text-red-600"
          @click="terminar(seccion)"
        >
          {{ textos.terminar }}
        </button>
      </li>
    </ul>
  </section>
</template>
